import React from 'react';
import JobList from '../../components/JobList/JobList';

const Home = () => {

    // rendering the home page here
    return (
        <>
            <JobList />
        </>
    );
};

export default Home;